import React from 'react';
import {ActionCreators} from '../../state/actions';
import Grid from '@mui/material/Grid';
import JuryPool from './JuryPool';
import {useDispatch} from 'react-redux';
import { useCase } from '../../db/hooks';
import JuryBox from './JuryBox';
import DismissedArea from './DismissedBox';
import useStyles from './Case.styles';
import { SharedJurorFiltersProvider } from './JurorFilterControls';


export default ({id: caseId}) => {
    const classes = useStyles();
    const spacing = 1;

    // Use Dexie hook for case data
    const { caseData } = useCase(caseId);
    const caseInfo = caseData || { civilCase: false, jurorsPerRow: 6, seatNumberStartPosition: 'topLeft', seatNumberFlow: 'standard', demographicCategories: [], showDemographics: false };

    const dispatch = useDispatch();

    const handleJurorEdit = React.useCallback((juror, emoji, occurrence) => {
        const jurorPayload = juror === 'new' ? {} : juror;
        dispatch(ActionCreators.openJurorModal(caseId, jurorPayload, null, "jury-box", emoji, occurrence));
    }, [caseId, dispatch]);

    return (
            <SharedJurorFiltersProvider>
            <Grid container spacing={2}>
                <Grid size={12} className={classes.juryBoxGridContainer}>
                    <JuryBox caseId={caseId}
                             key={"jury-box"}
                             civilCase={caseInfo.civilCase}
                             jurorsPerRow={caseInfo.jurorsPerRow || 6}
                             seatNumberStartPosition={caseInfo.seatNumberStartPosition || "topLeft"}
                             seatNumberFlow={caseInfo.seatNumberFlow || "standard"}
                             demographicCategories={caseInfo.demographicCategories}
                             showDemographics={caseInfo.showDemographics || false}
                             spacing={spacing}/>
                </Grid>
                <Grid size={12} className={classes.dismissedBoxGridContainer}>
                    <DismissedArea key={"dismissed-area"}
                                  caseId={caseId}
                                  civilCase={caseInfo.civilCase}
                                  demographicCategories={caseInfo.demographicCategories}
                                  showDemographics={caseInfo.showDemographics || false}/>

                </Grid>
                <Grid size={12} className={classes.juryPoolGridContainer}>

                    <JuryPool caseId={caseId}
                              key={"jury-pool"}
                              civilCase={caseInfo.civilCase}
                              demographicCategories={caseInfo.demographicCategories}
                              showDemographics={caseInfo.showDemographics || false}
                              onOpenEdit={handleJurorEdit}/>

                </Grid>
            </Grid>
            </SharedJurorFiltersProvider>
    );
}
